interface ScriptTagAttribute {
  type?: string,
  defer?: boolean,
  async?: boolean,
}

/**
 * 外部スクリプトを JS 経由で読み込ませます
 * @param url 読み込ませるファイルの URL
 */
export default function dynamicallyLoadScript(url: string, attribute?: ScriptTagAttribute): Promise<Event> {
  return new Promise((resolve, reject) => {
    const script = document.createElement('script')

    if (!url) reject(new Error('Invalid URL.'))

    script.src = url

    if (attribute) {
      if (attribute.async) script.async = true
      if (attribute.defer) script.defer = true
      if (attribute.type) script.type = attribute.type
    }

    document.body.appendChild(script)

    script.addEventListener('load', resolve)
    script.addEventListener('error', reject)
  })
}
